<template>
  <v-card>
    <v-toolbar
      color="primary"
      dark
    >
      <v-card-title>
        Documenti utili
      </v-card-title>
    </v-toolbar>
    <v-card-text class="subtitle-1">
      <br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/Breve procedura per l utilizzo della piattaforma ENEA rev2.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>1. Breve procedura per l'utilizzo della piattaforma EasyENEA
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/EasyENEA_FAQ_06_26.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>2. Domande frequenti
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/EasyENEA-ottimizzazione caricamento pratica.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>3. Guida all'ottimizzazione caricamento pratica
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/TutorialExportENEA.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>4.Tutorial ExportENEA Fattura Infissi
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/File marketing clienti.zip')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>5.File Marketing clienti
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/Documenti asseveratori.zip')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>6.Documenti asseveratori
          </v-btn>
      </v-row>
      <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/Guida al recupero delle informazioni del generatore di calore.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>7. Guida al recupero delle informazioni del generatore di calore
          </v-btn>
        </v-row>
        <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/Guida al recupero della visura catastale.pdf')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>8.Guida al recupero della visura catastale
          </v-btn>
      </v-row>
       <br><br>
      <v-row >
        <v-btn
            rounded
            color="success"
            @click="openInNewTab('/assets/Fac-simile dichiarazioni a cura del fornitore.zip')"
          >
            <v-icon
              left
              dark
            >
              fas fa-file-download
            </v-icon>9. Fac-simile Dichiarazioni a cura del fornitore
          </v-btn>
      </v-row>
      <br>
    
    </v-card-text>
   
 
  </v-card>
</template>
<script>
 import { mapGetters } from "vuex";
export default {
  data () {
    return {
    
    }
  },
  computed: {
    ...mapGetters({ user: "authentication/user" }),
  },
  methods: {
    openInNewTab (href) {
      Object.assign(document.createElement('a'), {
        target: '_blank',
        href: href,
      }).click();
    }
  }

}
</script>